import React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import { useColorModeValue } from '../../components/ui/color-mode';
import MainLayout from './MainLayout';
import Login from '../../pages/Login';
import RegistrationLogin from '../../pages/RegistrationLogin';
import NodeEnroll from '../../pages/NodeEnroll';
import Dashboard from '../../pages/Dashboard';
import WebSocketComponent from '../../shared/ui/TestWebSocketComponent';
import DigitalSign from '../../pages/DigitalSign/';
import FileUpload from '../../pages/FileUpload';
import PlaylistSetup from '../../pages/PlaylistSetup';
import TestAPI from '../../pages/TestApi';
import NodePlaylistManager from '../../pages/NodePlaylistManager';
import CreateAccount from '../../pages/CreateAccount';
import OnboardPage from '../../pages/Onboarding/OnboardPage';
import EditAccount from '../../pages/EditAccount';
import Sidebar from '../../components/aside/Sidebar.jsx';
import Navbar from '../../components/nav/Navbar.jsx';
import ProtectedRoute from './ProtectedRoute';

function App() {
	const [loggedIn, setLoggedIn] = useState(false);

	useEffect(() => {
		const sessionToken = localStorage.getItem('sessionToken');
		if (sessionToken) {
			const url = new URL('/api/auth/sessionVerify', window.location.origin);

			fetch(url, {
				method: 'GET',
				headers: {
					Accept: 'application/json',
					Authorization: `Bearer ${sessionToken}`,
				},
			})
				.then((response) => response.json())
				.then((data) => {
					if (data.expired) {
						console.log('Session expired, please log in again.');
					} else {
						setLoggedIn(true);
					}
				})
				.catch((error) => {
					console.error('Error verifying session:', error);
					setLoggedIn(false);
				});
		}
	});

	return (
		<Router>
			<Flex bg={useColorModeValue('gray.300', 'gray.900')} h={'vh'} w={'vw'}>
				<Routes>
					<Route path="/" element={<OnboardPage />} />
					<Route path="/CreateAccount" element={<CreateAccount />} />
					<Route path="/Login" element={<Login />} />
					<Route path="/registrationLogin" element={<RegistrationLogin />} />
					<Route
						path="/nodeEnroll"
						element={
							<ProtectedRoute>
								<NodeEnroll />
							</ProtectedRoute>
						}
					/>
					<Route
						path="/NodePlaylistManager"
						element={
							<ProtectedRoute>
								<NodePlaylistManager />
							</ProtectedRoute>
						}
					/>
					<Route element={<MainLayout />}>
						<Route
							path="/Dashboard/Landing"
							element={
								<ProtectedRoute>
									<Dashboard />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/websocket"
							element={
								<ProtectedRoute>
									<WebSocketComponent />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/digitalSign"
							element={
								<ProtectedRoute>
									<DigitalSign />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/fileUpload"
							element={
								<ProtectedRoute>
									<FileUpload />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/setup"
							element={
								<ProtectedRoute>
									<PlaylistSetup />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/testapi"
							element={
								<ProtectedRoute>
									<TestAPI />
								</ProtectedRoute>
							}
						/>
						<Route
							path="/EditAccount"
							element={
								<EditAccount />
							}
						/>
					</Route>

				</Routes>
			</Flex>
		</Router>
	);
}

export default App;
